// ToastHost — portal-mounted singleton that binds the toast store to the pure
// <Toast /> surface and renders it into document.body. Mounted once by
// RootLayout. The store binding lives here (shell → store, legal) so the ui
// component stays a pure consumer.
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Toast } from '../ui/index.js';
import { useToastStore } from '../stores/toast.js';

export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  // Delay portal target resolution to after first mount so SSR / test
  // environments without `document.body` don't crash.
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setTarget(typeof document !== 'undefined' ? document.body : null);
  }, []);
  if (!target) return null;
  return createPortal(<Toast toasts={toasts} onDismiss={dismiss} />, target);
}
